<div class="card flex-1">

  <div class="flex-1 d-flex fd-col ai-stretch">

    <ng-container *ngFor="let display of displays; trackBy: trackDisplay; let last=last">
      <div class="d-flex fd-row ai-stretch" [ngClass]="last ? 'flex-1' : ''" [style.flex]="last ? '1 1 0' : '0 0 0'">
        <!-- <mat-icon class="property-icon">{{ display.displayIcon }}</mat-icon> -->

        <div class="property-name-box" [style.flex]="'0 0 ' + (viewTile?.titleWidth ? viewTile.titleWidth : '37.5%')">
          <span class="property-name">{{ display.property?.displayName || '?' }}</span>
        </div>

        <div class="property-value-box">
          <suvo-bi-property [config]="display.config" [property]="display.property" [item]="item" [control]="display.control"
            [editItemMode]="editItemMode">
          </suvo-bi-property>
        </div>

      </div>
      <mat-divider *ngIf="!last"></mat-divider>
    </ng-container>


  </div>

</div>